import {useEffect} from 'react';
import {IntersectionOptions, useInView} from 'react-intersection-observer';
import {useWrapRef} from './useWrapRef.hook';

export function useExecuteInView({
  useInViewOptions,
  callback,
}: {
  useInViewOptions?: IntersectionOptions;
  callback?: Function;
}): (node?: Element | null) => void {
  const callbackRef = useWrapRef(callback);
  const {ref, inView, entry} = useInView({
    skip: !callback,
    ...useInViewOptions,
  });

  useEffect(() => {
    if (inView && entry?.target) {
      callbackRef.current?.(entry?.target);
    }
  }, [entry, inView, callbackRef]);

  return ref;
}
